import React from 'react';
import AdminLayout from './components/adminlayout';
import CancellationEdit from './components/cancellationedit';

const Cancellation = () => (
    <AdminLayout>
        <div className='p-6'>
            <div className='bg-white rounded-lg border border-gray-200 p-6'>
                <CancellationEdit />
            </div>
        </div>
    </AdminLayout>
);
export default Cancellation;
